import {
  GET_EMPLOYEE,
  GET_EMPLOYEE_SUCCESS,
  GET_EMPLOYEE_ERROR,
  ADD_EMPLOYEE,
  ADD_EMPLOYEE_SUCCESS,
  ADD_EMPLOYEE_ERROR,
  EDIT_EMPLOYEE,
  EDIT_EMPLOYEE_SUCCESS,
  EDIT_EMPLOYEE_ERROR,
  DELETE_EMPLOYEE,
  DELETE_EMPLOYEE_SUCCESS,
  DELETE_EMPLOYEE_ERROR,
  ADD_EMPLOYEE_LOG,
  GET_EMPLOYEE_SUMMARY,
  GET_EMPLOYEE_SUMMARY_SUCCESS,
  GET_EMPLOYEE_SUMMARY_ERROR,
} from "./actions";
import { omit } from "lodash";

const INIT_STATE = {
  employees: {},
  employee_logs: [],

  employee_summary: [],
  error: "",
  loading: false,
  initial_load: false,
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case ADD_EMPLOYEE:
      return {
        ...state,
        loading: true,
        error: "",
      };
    case ADD_EMPLOYEE_SUCCESS:
      return {
        ...state,
        employees: {
          ...state.employees,
          [action.payload.id]: action.payload,
        },
        loading: false,
        error: "",
      };
    case ADD_EMPLOYEE_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case GET_EMPLOYEE:
      return {
        ...state,
        loading: true,
        error: "",
      };

    case GET_EMPLOYEE_SUCCESS:
      return {
        ...state,
        loading: false,
        error: "",
        initial_load: true,
        employees: action.payload.employees,
      };
    case GET_EMPLOYEE_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload.message,
      };
    case EDIT_EMPLOYEE:
      return {
        ...state,
        loading: true,
        error: "",
      };

    case EDIT_EMPLOYEE_SUCCESS:
      return {
        ...state,
        loading: false,
        error: "",
        employees: {
          ...state.employees,
          [action.payload.id]: action.payload,
        },
      };
    case EDIT_EMPLOYEE_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload.message,
      };
    case DELETE_EMPLOYEE:
      return {
        ...state,
        loading: true,
        error: "",
      };
    case DELETE_EMPLOYEE_SUCCESS:
      return {
        ...state,
        loading: false,
        employees: omit(state.employees, action.payload),
      };
    case DELETE_EMPLOYEE_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload.message,
      };

    case ADD_EMPLOYEE_LOG:
      return {
        ...state,
        loading: false,
        employee_logs: [action.payload].concat(state.employee_logs),
      };

    case GET_EMPLOYEE_SUMMARY:
      return {
        ...state,
        loading: true,
        error: "",
      };

    case GET_EMPLOYEE_SUMMARY_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload.message,
      };
    case GET_EMPLOYEE_SUMMARY_SUCCESS:
      return {
        ...state,
        loading: false,
        employee_summary: action.payload,
      };

    default:
      return {
        ...state,
      };
  }
};
